/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { apartmentFilter, apartmentsState } from '../states/planner';

import useSite from './useSite';
import { useQuery } from '@tanstack/react-query';
import fetchApartments from './fetchApartments';

export const useApartments = () => {
  const [site] = useSite();
  const [, setApartments] = useAtom(apartmentsState);
  const [filteredApartments] = useAtom(apartmentFilter);

  const results = useQuery({
    queryKey: ['site', site.siteid, 'company', site.company, 'apartments'],
    queryFn: () => fetchApartments(site.company, site.siteid),
  });

  useEffect(() => {
    if (results.data)
      setApartments(results.data); // remove the length guard
    else if (results.isSuccess) setApartments([]);
  }, [results.data, results.isSuccess, setApartments]);

  return filteredApartments;
};
